import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { AppState } from "../../reducers";
import { select, Store } from "@ngrx/store";
import { DecimalService } from "../../global/pipes/decimal.pipe";
import {
  BehaviorSubject,
  combineLatest,
  Observable,
  of,
  Subscription,
} from "rxjs";
import {
  Month,
  formatDate,
  getEndDateOfMonthByMonthAndYear,
  getStartDateOfMonthByMonthAndYear,
} from "../../global/dates";
import {
  selectCountrySelected,
  selectMainFilterSelectedAccount,
  selectMainFilterSelectedClient,
  selectMainPageNotes,
  selectStaticData,
} from "../../shared/layout/main.selectors";
import {
  LoadTaxDetailsAction,
  LoadTaxDetailsDatesAction,
  ResetTaxDetailsDataAction,
  SetTaxDetailsDateFilterAction,
  SetTaxDetailsSortAction,
  SetTaxDetailsStartEndFinancialYear,
  SetTaxDetailsYearFilterAction,
  TaxDetailsFileDownloadAction,
} from "./tax-details.actions";
import { distinctUntilChanged, filter, map, take } from "rxjs/operators";
import { isEqual, sortBy } from "lodash";
import {
  selectTaxDetailsData,
  selectTaxDetailsDateFilter,
  selectTaxDetailsDates,
  selectTaxDetailsDatesMax,
  selectTaxDetailsFinancialEndDate,
  selectTaxDetailsFinancialStartDate,
  selectTaxDetailsLoading,
  selectTaxDetailsTotal,
  selectTaxDetailsYearFilter,
  selectTaxDetailsYears,
  selectTaxDetailsfinancialYearDate,
  selectTaxDetailsPIR,
  selectTaxDetailsFilter,
} from "./tax-details.selectors";
import { isNullOrUndefined } from "util";
import {
  ColumnDef, CommonConstants,
  PageNotes,
  SortInfo,
  TableHeader,
} from "../../global/interfaces";
import {
  selectAuthUserFinancialYearStartMonth,
  selectAuthUserRole,
  selectAuthUserType,
} from "../auth/auth.selectors";
import * as moment from "moment";
// import { AddErrorToastAction } from "../toaster/toaster.actions";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import * as pdfMake from "pdfmake/build/pdfmake";
import { georgiaFontFamily, georgiaFontVfs } from "../../shared/pdfs/georgia-font";
import { getDataUri } from "../../global/getDataUri";
import { selectConsultants } from "../features.selectors";
import { DecimalPipe } from "@angular/common";
import { pdfFooter, pdfHeader, pdfStyle } from "../../shared/pdfs/templates";
import { TableColumnAlignment } from 'atlas-table';
import { Actions, FieldSize } from "atlas-cdk";
import { DropdownPlacement, DropdownTriggerType } from 'atlas-menu';
import { ToastService } from "../../shared/toaster_/toaster_.service";

@Component({
  standalone: false,
  selector: "dsp-tax-details",
  templateUrl: "./tax-details.component.html",
  styleUrls: ["./tax-details.component.scss"],
})
export class TaxDetailsComponent implements OnInit, OnDestroy {

  dropdownTriggerTypeIconButton = DropdownTriggerType.IconButton;
  dropdownPlacementLeftStart = DropdownPlacement.LeftStart;
  sizeMedium = FieldSize.medium;

  public headers: ColumnDef[] = [
    {
      displayLabel: 'Name',
      fieldKey: 'fundName',
      column: 'fundName',
      sortable: true,
    },
    {
      displayLabel: ' Gross Taxable Income / Loss ($)',
      fieldKey: 'taxableIncomeYTD',
      align: TableColumnAlignment.right,
      sortable: true,
      column: 'taxableIncomeYTD',
    },
    {
      displayLabel: 'Rebate and Expenses ($)',
      fieldKey: 'managementFeeRebateYTD',
      align: TableColumnAlignment.right,
      sortable: true,
      column: 'managementFeeRebateYTD',
    },
    {
      displayLabel: 'Total Taxable Income / Loss ($)',
      fieldKey: 'totalTaxIncome',
      align: TableColumnAlignment.right,
      sortable: true,
      column: 'totalTaxIncome',
    },
    {
      displayLabel: 'Foreign Tax Credits ($)',
      fieldKey: 'foreignTaxCreditYTD',
      align: TableColumnAlignment.right,
      sortable: true,
      column: 'foreignTaxCreditYTD',


    },
    {
      displayLabel: 'Foreign Dividend Withholding Payment Credits ($)',
      fieldKey: 'fdwpCreditYTD',
      align: TableColumnAlignment.right,
      sortable: true,
      column: 'fdwpCreditYTD',
    },
    {
      displayLabel: 'Resident Withholding Tax Credits ($)',
      column: 'rwtCreditYTD',
      align: TableColumnAlignment.right,
      sortable: true,
      fieldKey: 'rwtCreditYTD',
    },
    {
      displayLabel: ' Imputation Credits ($)',
      column: 'imputationCreditYTD',
      align: TableColumnAlignment.right,
      sortable: true,
      fieldKey: 'imputationCreditYTD'
    },
    {
      displayLabel: 'Tax Liability / Rebate ($)**',
      column: 'netTaxLiability',
      align: TableColumnAlignment.right,
      sortable: true,
      fieldKey: 'netTaxLiability',
    }
  ];


  public months$: Observable<Month[]>;
  public yearFilterOptions$: Observable<{ label: number; value: number }[]>;
  public date$: Observable<string>;
  public pirValue$: Observable<number>;
  public loading$: Observable<boolean>;
  public country = "";
  public message;
  public notes$: BehaviorSubject<PageNotes> = new BehaviorSubject<PageNotes>(
    {} as PageNotes
  );
  public sort$: BehaviorSubject<SortInfo> = new BehaviorSubject<SortInfo>({
    column: "fundName",
    reverse: false,
  });
  public asAtViewDate$: Observable<string>;
  public selectedYear$: BehaviorSubject<number> = new BehaviorSubject(0);
  public maxDate$: Observable<string | undefined>;
  public minDate$: Observable<string | undefined>;
  public data$: Observable<any>;
  public total: any;
  public financialYearmonth;
  public showTaxDetailsData$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public accountId;

  public asAt: string;
  public year: any;

  private readonly subscription: Subscription = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly decimalPipe: DecimalPipe,
    private readonly store: Store<AppState>,
    private readonly decimal: DecimalService,
    private readonly _toasterService: ToastService
  ) {
    this.loading$ = this.selectLoading();
    this.yearFilterOptions$ = this.selectYears().pipe(
      map(years => years.map(year => ({
        label: year,
        value: year
      })))
    );
    this.minDate$ = this.selectMinDate();
    this.maxDate$ = this.selectMaxDate();
    this.data$ = this.selectDisplayData();
    this.asAtViewDate$ = this.selectAsAtViewDate();
    this.pirValue$ = this.selectPIR();

  }

  ngOnInit() {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeLoadCheck());
    this.subscription.add(this.subscribeLoadTaxDetailsDates());
    this.subscription.add(this.subscribeInitialYearFilter());
    this.subscription.add(this.subscribeInitialAsAtFilter());
    this.subscription.add(this.subscribeYearFilter());
    this.subscription.add(this.subscribeLoadTaxDetails());
    this.subscription.add(this.subscribeAsAtFilter());
    this.subscription.add(this.subscribeSelectedClient());
    this.subscription.add(this.subscribeNotes());
  }

  private subscribeLoadTaxDetailsDates(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
    ])
      .pipe(distinctUntilChanged(isEqual))
      .subscribe(([account]) => {
        if (!!account) {
          this.accountId = account._id;
          this.store.dispatch(
            new LoadTaxDetailsDatesAction({ account: account._id })
          );
        } else {
          this.store.dispatch(new ResetTaxDetailsDataAction());
        }
      });
  }
  private selectLoading(): Observable<boolean> {
    return this.store.pipe(select(selectTaxDetailsLoading));
  }
  private selectYears(): Observable<number[]> {
    return this.store.pipe(select(selectTaxDetailsYears));
  }

  private selectMinDate(): Observable<string | undefined> {
    return this.store.pipe(
      select(selectTaxDetailsFinancialStartDate),
      map((min) =>
        min ? min.format(CommonConstants.DBDateFormat) : undefined
      )
    );
  }

  private selectMaxDate(): Observable<string | undefined> {
    return this.store.pipe(
      select(selectTaxDetailsFinancialEndDate),
      map((max) =>
        max ? max.format(CommonConstants.DBDateFormat) : undefined
      )
    );
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store
      .pipe(select(selectCountrySelected))
      .subscribe((country) => {
        this.country = country;
        if (country === "au") {
          this.router.navigate(["/overview"]);
        }
      });
  }

  private selectDisplayData(): Observable<any> {
    return combineLatest([
      this.store.pipe(select(selectTaxDetailsData)),
      this.store.pipe(select(selectTaxDetailsTotal)),
      this.sort$,
    ]).pipe(
      map(([data, total, sort]) => {
        if (!isNullOrUndefined(data) && !isNullOrUndefined(total)) {
          const sortedData = sort.reverse
            ? sortBy(data, sort.column).reverse()
            : sortBy(data, sort.column);
          if (data.length > 1) {
            this.total = total;
            return [...sortedData];
          } else {
            this.total = total[0];
            return [...sortedData];
          }
        }
      })
    );
  }

  private subscribeLoadTaxDetails(): Subscription {
    return combineLatest(
      [
        this.store.pipe(select(selectTaxDetailsDateFilter)),
        this.store.pipe(select(selectMainFilterSelectedAccount)),
        // this.store.pipe(select(selectTaxDetailsfinancialYearDate)),
        this.store.pipe(select(selectTaxDetailsFinancialStartDate))
      ]
    ).pipe(
      distinctUntilChanged(isEqual)
    ).subscribe(([date, accountId, financialYearDate]) => {

      // const startDateofFinancialYear = financialYearDate && financialYearDate.startDateofFinancialYear ?
      //   financialYearDate.startDateofFinancialYear : undefined;
      const startDateofFinancialYear =
        financialYearDate ? financialYearDate.format(CommonConstants.DBDateFormat) : undefined;
      if (!!accountId && !!date) {

        this.store.dispatch(new LoadTaxDetailsAction({
          account: accountId._id || '', date, country: this.country,
          startDate: startDateofFinancialYear
        }));
      } else {
        this.store.dispatch(new ResetTaxDetailsDataAction());
      }
    });
  }
  private subscribeSelectedClient(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectAuthUserRole)),
    ])
      .pipe(
        filter(([client]) => !!client),
        distinctUntilChanged(isEqual),
        map(
          ([
            client,
            account,
            country,
            selectAuthUserType,
            selectAuthUserRole,
          ]) => ({
            client,
            account,
            country,
            selectAuthUserType,
            selectAuthUserRole,
          })
        )
      )
      .subscribe((payload) => {
        if (payload.country === "nz") {
          if (
            payload.selectAuthUserType === "external" &&
            payload.selectAuthUserRole === "consultant"
          ) {
            if (!payload.client.taxDetail) {
              this.router.navigate(["/overview"]);
            }
          }
        }
      });
  }
  private subscribeLoadCheck(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
    ])
      .pipe(distinctUntilChanged(isEqual))
      .subscribe(([selectAuthUserType, selectedClient]) => {
        this.showTaxDetailsData$.next(false);
        if (selectAuthUserType === "internal") {
          if (
            isNullOrUndefined(selectedClient) ||
            (!isNullOrUndefined(selectedClient) &&
              (isNullOrUndefined(selectedClient.taxDetail) ||
                selectedClient.taxDetail === false))
          ) {
            this.message = CommonConstants.taxDetailsOffMessage;
          } else {
            this.message = CommonConstants.taxDetailsOnMessage;
            this.showTaxDetailsData$.next(true);
          }
        } else if (
          !isNullOrUndefined(selectedClient) &&
          !isNullOrUndefined(selectedClient.taxDetail) &&
          selectedClient.taxDetail === true
        ) {
          this.showTaxDetailsData$.next(true);
        }
      });
  }

  private selectAsAtViewDate(): Observable<string> {
    return this.store.pipe(
      select(selectTaxDetailsDateFilter),
      filter((date) => !!date),
      map((date) => formatDate(date, "DD/MM/YYYY"))
    );
  }

  private selectPIR(): Observable<number> {
    return this.store.pipe(select(selectTaxDetailsPIR));
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onExportPDF(value): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.data$,
      this.store.pipe(select(selectTaxDetailsFilter)),
      this.store.pipe(select(selectTaxDetailsDateFilter)),
      this.store.pipe(select(selectTaxDetailsPIR)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants)),
      this.store.pipe(select(selectTaxDetailsFinancialStartDate)),
    ])
      .pipe(
        filter(([client, account]) => !!account),
        map(
          ([
            client,
            account,
            data,
            filter,
            date,
            pir,
            staticData,
            pageNotes,
            consultants,
            startDate,
            //value,
          ]) => ({
            client: client.name,
            accountName: account.name,
            accountNumber: account.number,
            data,
            year: filter.year,
            date,
            pir,
            staticData,
            pageNotes,
            consultants,
            startDate,
            country: this.country,
          })
        ),
        take(1)
      )
      .subscribe((payload) => {
        const mmcLogo = [],
          mercerLogo = [],
          icons = [],
          asAtViewDate = payload.date,
          startDate = payload.startDate,
          pir = payload.pir,
          promises = [];
        promises.push(
          getDataUri(
            "assets/images/mmc_logo.png",
            CommonConstants.pdfMmcLogoWidth,
            CommonConstants.pdfMmcLogoHeight
          ).then((data) => mmcLogo.push(data))
        );
        promises.push(
          getDataUri(
            "assets/images/mercer_brand_logo.png",
            CommonConstants.pdfMercerLogoWidth,
            CommonConstants.pdfMercerLogoHeight
          ).then((data) => mercerLogo.push(data))
        );
        promises.push(
          getDataUri("assets/images/phone.png", 18, 18).then(
            (data) => (icons["phone"] = data)
          )
        );
        promises.push(
          getDataUri("assets/images/email.png", 18, 18).then(
            (data) => (icons["email"] = data)
          )
        );
        promises.push(
          getDataUri("assets/images/website.png", 18, 18).then(
            (data) => (icons["website"] = data)
          )
        );
        if (payload.data.length > 0) {
          const body = [...payload.data, this.total].map((data) => [
            {
              text:
                data.fundName === "Total"
                  ? {
                    text: data.fundName || "-",
                    style: "textCellSI",
                    bold: true,
                  }
                  : { text: data.fundName || "-", style: "textCellSI" },
            },
            {
              text:
                data.taxableIncomeYTD !== "N/A" ? data.taxableIncomeYTD : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            {
              text: data.managementFeeRebateYTD
                ? data.managementFeeRebateYTD
                : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            {
              text: data.totalTaxIncome ? data.totalTaxIncome : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            {
              text: data.foreignTaxCreditYTD ? data.foreignTaxCreditYTD : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            {
              text: data.fdwpCreditYTD ? data.fdwpCreditYTD : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            {
              text: data.rwtCreditYTD ? data.rwtCreditYTD : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            {
              text: data.imputationCreditYTD ? data.imputationCreditYTD : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
            // {
            //   text: (data.taxToPayCredit !== 'N/A') ? data.taxToPayCredit : 'N/A',
            //   style: data.fundName === 'Total' ? 'numberCellTaxDetails' : 'numberCellSI'
            // },
            // {
            //   text: (data.taxPaid !== 'N/A') ? data.taxPaid : 'N/A',
            //   style: data.fundName === 'Total' ? 'numberCellTaxDetails' : 'numberCellSI'
            // },
            {
              text:
                data.netTaxLiability !== "N/A" ? data.netTaxLiability : "N/A",
              style:
                data.fundName === "Total"
                  ? "numberCellTaxDetails"
                  : "numberCellSI",
            },
          ]);

          setTimeout(() => {
            Promise.all(promises).then(() => {
              const title = "Tax Details Report",
                address = [];
              address.push(
                {
                  text: !isNullOrUndefined(payload.staticData.entityName)
                    ? `${payload.staticData.entityName}`
                    : "",
                  style: "clientTitle",
                  pageBreak: "before",
                },
                {
                  text: !isNullOrUndefined(payload.staticData.address)
                    ? `${payload.staticData.address}`
                    : "",
                  style: "clientAddress",
                }
              );
              const docDefinition = {
                pageOrientation: "landscape",
                content: [
                  { text: title, style: "title" },
                  { text: "" },
                  {
                    text:
                      moment(startDate).format(
                        CommonConstants.displayDateFormatInAU
                      ) +
                      " - " +
                      moment(asAtViewDate).format(
                        CommonConstants.displayDateFormatInAU
                      ),
                    style: "subtitle",
                  },
                  {
                    text: `${payload.client} - ${payload.accountName} - ${payload.accountNumber}`,
                    style: "subsubtitle",
                  },
                  {
                    text:
                      "Date Generated: " +
                      moment().format(CommonConstants.displayDateFormatInAU),
                    style: "subtitleDate",
                  },
                  {
                    columns: [
                      {
                        text: "PIE Tax Information",
                        style: "PirAndPieTitle",
                        bold: true,
                      },
                      {
                        text: "Prescribed Investor Rate (PIR)",
                        style: "PirAndPieTitle",
                        alignment: "right",
                        bold: true,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `As at ${moment(asAtViewDate).format(
                          CommonConstants.simpleDateFormatInAU
                        )}`,
                        style: "PirAndPieDate",
                      },
                      {
                        text: `As at ${moment(asAtViewDate).format(
                          CommonConstants.simpleDateFormatInAU
                        )}`,
                        alignment: "right",
                        style: "PirAndPieDate",
                      },
                    ],
                  },
                  {
                    text: `${pir}`,
                    style: "PirValue",
                    alignment: "right",
                  },
                  {
                    table: {
                      headerRows: 1,
                      widths: [
                        "20%",
                        "10%",
                        "10%",
                        "10%",
                        "10%",
                        "10%",
                        "10%",
                        "10%",
                        "10%",
                        // "10.5%",
                        // "10.5%",
                      ],
                      dontBreakRows: true,
                      body: [
                        [
                          { text: "Name", style: "tableHeaderTaxDetails" },
                          {
                            text: "Gross Taxable Income / Loss ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          {
                            text: "Rebate and Expenses ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          {
                            text: "Total Taxable Income / Loss ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          {
                            text: "Foreign Tax Credits ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          {
                            text: "Foreign Dividend Withholding Payment Credits ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          {
                            text: "Resident Withholding Tax Credits ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          {
                            text: "Imputation Credits ($)",
                            style: "tableHeaderTaxDetails",
                          },
                          //{ text: 'TAX TO PAY AFTER CREDITS ($)', style: 'tableHeaderTaxDetails' },
                          //{ text: 'TAX PAID ($)', style: 'tableHeaderTaxDetails' },
                          {
                            text: "Tax Liability / Rebate ($)**",
                            style: "tableHeaderTaxDetails",
                          },
                        ],
                        ...body,
                      ],
                    },
                    layout: {
                      hLineWidth: function (i, node) {
                        return 1;
                      },
                      vLineWidth: function (i, node) {
                        return 1;
                      },
                      hLineColor: function (i, node) {
                        return "white";
                      },
                      vLineColor: function (i, node) {
                        return "white";
                      },
                    },
                  },

                  {
                    text: "*The PIE Tax Information detail the taxable income and the relevant components allocated to you during the PIE tax year to date",
                    colour: "#003865",
                    style: "notesPieTax",
                  },
                  {
                    text: "**Please note that any negative values are a rebate for the Tax Liability / Rebate ($) column",
                    colour: "#003865",
                    style: "notes",
                  },
                  {
                    text: "***If you need to update your Prescribed Investor Rate (PIR), please contact us",
                    colour: "#003865",
                    style: "notes",
                  },
                  ...payload.consultants.map((consultant) => [
                    {
                      text:
                        `${consultant.firstName} ${consultant.lastName}` || "",
                      style: "consultantName",
                    },
                    {
                      columns: [
                        // {
                        //   image: icons["phone"],
                        //   width: 15,
                        //   height: 11,
                        //   margin: [0, 0, 0, 10],
                        // },
                        {
                          text: `${consultant.phone}` || "",
                          style: "consultantPhone",
                        },
                      ],
                    },
                    {
                      columns: [
                        // {
                        //   image: icons["email"],
                        //   width: 15,
                        //   height: 11,
                        //   margin: [0, 0, 0, 10],
                        // },
                        {
                          text: `${consultant.username}` || "",
                          style: "consultantMail",
                        },
                      ],
                    },
                  ]),
                  {
                    text: "Mercer Multi Manager Fund Contact Details",
                    style: "fundContactTitle",
                    pageBreak: "before",
                  },
                  {
                    columns: [
                      // {
                      //   image: icons["phone"],
                      //   width: 15,
                      //   height: 11,
                      //   margin: [0, 0, 0, 10],
                      // },
                      {
                        text: `${payload.staticData.phone || ""}`,
                        style: "fundContactPhone",
                      },
                    ],
                  },
                  {
                    columns: [
                      // {
                      //   image: icons["email"],
                      //   width: 15,
                      //   height: 11,
                      //   margin: [0, 0, 0, 10],
                      // },
                      {
                        text: `${payload.staticData.email || ""}`,
                        style: "fundContactEmail",
                      },
                    ],
                  },
                  {
                    columns: [
                      // {
                      //   image: icons["website"],
                      //   width: 15,
                      //   height: 11,
                      //   margin: [0, 0, 0, 10],
                      // },
                      {
                        text: `${payload.staticData.website || ""}`,
                        style: "fundContactWebsite",
                      },
                    ],
                  },
                  {
                    text: CommonConstants.importantNotices,
                    style: "noticeTitle",
                    pageBreak: "before",
                  },
                  {
                    text: payload.staticData.importantNotices,
                    style: "noticeData",
                  },
                  ...address,
                ],
                styles: {
                  ...pdfStyle,
                  footnote: {
                    fontSize: 9,
                    margin: [0, 10, 0, 0],
                  },
                },
                footer(currentPage: number, totalPages: number) {
                  return pdfFooter(
                    currentPage,
                    totalPages,
                    payload,
                    mmcLogo[0]
                  );
                },
                header(currentPage: number, totalPages: number) {
                  return pdfHeader(mmcLogo, title, currentPage, totalPages);
                },
                pageMargins: [40, 90, 40, 100],
              };
              pdfMake.vfs = {
                ...(pdfFonts.pdfMake as any).vfs,
                ...georgiaFontVfs,
              };
              pdfMake.fonts = {
                ...georgiaFontFamily,
                Roboto: {
                  normal: "Roboto-Regular.ttf",
                  bold: "Roboto-Medium.ttf",
                  italics: "Roboto-Italic.ttf",
                  bolditalics: "Roboto-MediumItalic.ttf",
                },
              };
              pdfMake.createPdf(docDefinition).download("TaxDetailsExport.pdf");
            });
          }, 1000);
        } else {
          // this.store.dispatch(
          //   new AddErrorToastAction(
          //     `There is no data in specified ${this.asAtViewDate$}.`
          //   )
          // );
          return this._toasterService.launchAlertError(`There is no data in specified ${this.asAtViewDate$}.`, Actions.error);
        }
      });
  }
  public onExportCSV(): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.data$,
      this.store.pipe(select(selectTaxDetailsFilter)),
      this.store.pipe(select(selectTaxDetailsFinancialStartDate)),
      this.store.pipe(select(selectTaxDetailsPIR)),
      this.store.pipe(select(selectTaxDetailsDateFilter)),
    ]
    ).pipe(
      filter(([client, account]) => !!account),
      map(([client, account, data, filter, startDate, pir, date]) =>
      ({
        id: account._id,
        client: client.name,
        accountName: account.name,
        accountNumber: account.number,
        data,
        year: filter.year,
        startDate,
        pir,
        date,
        country: this.country,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      )),
      take(1)
    ).subscribe(payload => {
      const startDate =
        payload.startDate ? payload.startDate.format(CommonConstants.DBDateFormat) : undefined;
      payload = { ...payload, startDate: moment.utc(startDate) };
      if (payload.date) {
        // @ts-ignore
        payload = {
          ...payload, country: this.country,
        };
        this.store.dispatch(new TaxDetailsFileDownloadAction(payload));
      } else {
        // this.store.dispatch(new AddErrorToastAction(`There is no data in specified ${this.year}.`));
        return this._toasterService.launchAlertError(`There is no data in specified ${this.year}.`, Actions.error);
      }
    });
  }

  private subscribeAsAtFilter(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectTaxDetailsDatesMax)),
      this.store.pipe(select(selectAuthUserFinancialYearStartMonth)),
      // this.selectedYear$
      this.store.pipe(select(selectTaxDetailsYearFilter))
    ]).pipe(
      filter(([max, financialYearStartMonth, selectedYear]) => max !== undefined &&
        financialYearStartMonth !== undefined && selectedYear !== undefined)
    ).subscribe(([max, financialYearStartMonth, selectedYear]) => {
      this.asAt = max.utc().format();
      const startDateofFinancialYear = getStartDateOfMonthByMonthAndYear(financialYearStartMonth, selectedYear, 'YYYY-MM-DD'),
        endDateofFinancilaYear = getEndDateOfMonthByMonthAndYear(financialYearStartMonth - 1, selectedYear + 1, 'YYYY-MM-DD');
      // this.store.dispatch(new SetTaxDetailsStartEndFinancialYear({ startDateofFinancialYear, endDateofFinancilaYear }));
      if ((new Date(endDateofFinancilaYear)).getTime() < (new Date(this.asAt)).getTime()) {
        this.asAt = endDateofFinancilaYear;
      }
      this.store.dispatch(new SetTaxDetailsStartEndFinancialYear({ startDateofFinancialYear, endDateofFinancilaYear: this.asAt }));
    });
  }
  private subscribeInitialAsAtFilter(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectTaxDetailsDates)),
      this.store.pipe(select(selectTaxDetailsDateFilter)),
    ])
      .pipe(filter(([dates]) => dates && dates.max !== undefined))
      .subscribe(([dates, asAt]) => {
        if (asAt === undefined) {
          this.store.dispatch(new SetTaxDetailsDateFilterAction(dates.max));
        }
      });
  }
  private subscribeInitialYearFilter(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectTaxDetailsYears)),
      this.store.pipe(select(selectTaxDetailsYearFilter)),
    ])
      .pipe(
        filter(([years]) => !!years.length),
        map(([years, year]) => {
          if (years.length >= 2) {
            year = year !== undefined ? year : years[0];
            return year;
          } else {
            year = year !== undefined ? year : years[years.length - 1];
            return year;
          }
        })
      )
      .subscribe((year) => {
        this.store.dispatch(new SetTaxDetailsYearFilterAction(year));
      });
  }
  private subscribeYearFilter(): Subscription {
    return this.store.pipe(
      select(selectTaxDetailsYearFilter)
    ).subscribe(year => {
      this.year = year !== undefined ? year : undefined;

    });
  }

  public onChangeYear(event): void {

    if (event) {
      this.store.dispatch(new SetTaxDetailsYearFilterAction(event));
    }
  }
  public onChangeAsAt(event: string): void {

    const date = new Date(event);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const formatted = `${year}-${month}-${day}`;


    this.store.pipe(
      select(selectTaxDetailsDateFilter),
      take(1)
    ).subscribe(() => {
      // formatDate(event, CommonConstants.DBDateFormat)

      this.store.dispatch(new SetTaxDetailsDateFilterAction(formatted));
    });
  }
  public onSort(sort: SortInfo): void {
    // this.sort$.next(event);
    this.store.dispatch(new SetTaxDetailsSortAction(sort));
  }
  private subscribeNotes(): Subscription {
    return this.store.pipe(select(selectMainPageNotes)).subscribe(this.notes$);
  }
}
